




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ADDPOSTINTERNSHIP= createAsyncThunk(
  "addpostinternship/addpostinternship",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addpostinternshipSlice = createSlice({
  name: "addpostinternshipSlice",
  initialState: {
    addpostinternship: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddpostinternship: (state) => {
        state.addpostinternship.loading = false
        state.addpostinternship.error = false
        state.addpostinternship.data = []
        state.addpostinternship.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDPOSTINTERNSHIP.fulfilled, (state, action) => {
      state.addpostinternship = {
        ...state.addpostinternship,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTINTERNSHIP.pending, (state, action) => {
      state.addpostinternship = {
        ...state.addpostinternship,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTINTERNSHIP.rejected, (state, action) => {
      state.addpostinternship = {
        ...state.addpostinternship,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addpostinternshipAction = {
    ADDPOSTINTERNSHIP,
};

export { addpostinternshipAction };
export default addpostinternshipSlice.reducer;
export const {setInitialStateOfaddpostinternship} = addpostinternshipSlice.actions
